export function arrayToMap(existingArray, keyForMap) {
    if (!existingArray || !Array.isArray(existingArray) || (existingArray === null || existingArray === void 0 ? void 0 : existingArray.length) === 0)
        return { columnMap: {} };
    var columnMap = existingArray.reduce(function (map, obj, indx) {
        map[obj === null || obj === void 0 ? void 0 : obj[keyForMap]] = obj;
        return map;
    }, {});
    return columnMap;
}
//# sourceMappingURL=common.js.map